import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import moment from "moment";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const JournalChart = ({ events, chartTtile }) => {
    const labels = events.map(e => moment(e.date).format("D MMM"));

    const data = {
        labels,
        datasets: [
            {
                label: "Activity",
                data: events.map(e => e.Activity),
                backgroundColor: "#4CAF50",
            },
            {
                label: "Observation",
                data: events.map(e => e.Observation),
                backgroundColor: "#2196F3",
            },
            {
                label: "Vitals",
                data: events.map(e => e.Vitals),
                backgroundColor: "#FF6384", 
            }
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: "top" },
            tooltip: {
                callbacks: {
                    footer: (items) => {
                        const total = items.reduce((sum, i) => sum + (i.raw || 0), 0);
                        return `Total: ${total}`;
                    },
                },
            },
        },
        scales: {
            x: { stacked: true },
            y: {
                stacked: true,
                beginAtZero: true,
                title: { display: true, text: "Event Count" },
            },
        },
    };

    return (
        <div className="card shadow-sm mb-4 h-full">
            <div className="card-header text-center text-xl font-bold text-gray-700">
                {chartTtile || "Journal Events Chart"}
            </div>
            <div className="card-body" style={{ height: "300px" }}>
                {events && events.length > 0 ? (
                    <Bar data={data} options={options} />
                ) : (
                    <p className="text-gray-500 font-semibold flex items-center justify-center h-full">
                        No data found for selected criteria
                    </p>
                )}
            </div>
        </div>    );
};

            export default JournalChart;
